import type { DropdownOption } from '@pixum/dropdown';

export const FormStatus = {
  hidden: 'hidden',
  visible: 'visible',
  successful: 'successful',
} as const;

export type FormStatusType = (typeof FormStatus)[keyof typeof FormStatus];

export type UIStoreState = {
  isAuthUIVisible: boolean;
  contactForm: {
    status: FormStatusType;
    fromName: string;
    fromEMail: string;
    text: string;
    sampleMessage: string;
    availableSubjects?: DropdownOption[];
    selectedSubject?: DropdownOption;
    cancellationErrors: { orderError?: string; productsError?: string };
  };
};

export type UIStoreActions = {
  setAuthUIVisibility: (isVisible: UIStoreState['isAuthUIVisible']) => void;
  setContactFormFields: (fields: Partial<Omit<UIStoreState['contactForm'], 'status'>>) => void;
  setContactMessageToSample: (orderId: string) => void;
  setContactFormStatus: (status: FormStatusType) => void;
  setContactFormSubjectToMissingOrder: () => void;
  setContactFormSubjectToCancellation: () => void;
  resetContactForm: () => void;
  setCancellationErrors: (errors: { orderError?: string; productsError?: string }) => void;
};

export type UIStore = UIStoreState & UIStoreActions;

export type UIStoreSelector = (store: UIStore) => UIStore;

export const defaultUIStoreState: UIStoreState = {
  isAuthUIVisible: false,
  contactForm: {
    status: FormStatus.hidden,
    fromName: '',
    fromEMail: '',
    text: '',
    sampleMessage: '',
    availableSubjects: [],
    selectedSubject: undefined,
    cancellationErrors: {},
  },
};
